import {
  createOverlay,
  type BaseOverlay,
  type BaseOverlayOptions,
  createBaseOverlay,
} from '@/shared/lib'

export type RoomOverlayProps = Omit<BaseOverlayOptions, 'map' | 'position'> & {
  roomId: number
}

type RoomOverlayOptions = BaseOverlayOptions & RoomOverlayProps

export interface RoomOverlay extends BaseOverlay {
  roomId: number
  isViewing: boolean
  markAsViewing(): void
  markAsViewed(): void
}

export const createRoomOverlay = () => {
  const BaseOverlay = createBaseOverlay()

  const RoomOverlay = createOverlay<RoomOverlay, RoomOverlayOptions>({
    base: BaseOverlay,
    initialize,
  })

  function initialize(this: RoomOverlay, options: RoomOverlayOptions) {
    this.roomId = options.roomId
    this.isViewing = false
    this._onClick = () => {
      this.markAsViewing()
      options.onClick?.()
    }
  }

  RoomOverlay.prototype.markAsViewing = function () {
    if (this._element.firstElementChild instanceof HTMLElement) {
      this.isViewing = true
      this._element.firstElementChild.classList.add('viewing')
    }
  }

  RoomOverlay.prototype.markAsViewed = function () {
    if (this._element.firstElementChild instanceof HTMLElement) {
      this.isViewing = false
      this._element.firstElementChild.classList.remove('viewing')
      this._element.firstElementChild.classList.add('has-viewed')
    }
  }

  return RoomOverlay
}
